<ion-header>
  <ion-toolbar color="primary">
    <ion-title>
      <div class="logo-box">
        <ion-img [src]="srcLogo" class="logo" alt="Logo" routerLink="/"></ion-img>
      </div>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ng-container *ngIf="isAuthenticated$ | async">
      <ion-list-header>
        <ion-icon
          class="ion-margin-end"
          [src]="'account' | getIcon"
          color="secondary"
          size="large"
        ></ion-icon>
        <ion-label>Utente corrente</ion-label>
      </ion-list-header>

      <!-- current user info -->

      <!-- name -->
      <ion-item *ngIf="currentUserPersonalData$ | async; let userData">
        <ion-label><strong>Nome</strong></ion-label>
        <ion-input
          class="ion-text-end"
          readonly
          [value]="userData.surname ? userData.surname + ' ' + userData.name : ''"
          placeholder="Sconosciuto"
        >
        </ion-input>
      </ion-item>

      <!-- structure selection -->
      <ion-item>
        <ion-label><strong>Struttura</strong></ion-label>
        <ion-select
          [ngModel]="currentStructureId$ | async"
          (ngModelChange)="onStructureChange($event)"
          interface="popover"
          [interfaceOptions]="{
            showBackdrop: false,
            cssClass: 'app-popover-select app-popover-select-overflow'
          }"
        >
          <ion-select-option
            *ngFor="let structure of structures$ | async"
            [value]="structure.structureId"
          >
            <span *ngIf="structure.structureId !== structure.trecUserId">{{
              structure.description
            }}</span>
            <span *ngIf="structure.structureId === structure.trecUserId">Io</span>
          </ion-select-option>
        </ion-select>
      </ion-item>

      <!-- current patient info -->
      <ng-container *ngIf="isPhysician$ | async">
        <ng-container *ngIf="patient$ | async; let patient">
          <ng-container *ngIf="userId$ | async; let currentUserId">
            <ng-container *ngIf="patient?.id !== currentUserId">
              <ion-list-header class="section-header">
                <ion-icon
                  class="ion-margin-end"
                  [src]="'account-heart' | getIcon"
                  color="secondary"
                  size="large"
                >
                </ion-icon>
                <ion-label>Paziente</ion-label>
              </ion-list-header>

              <ion-item>
                <ion-label><strong>Nome</strong></ion-label>
                <ion-input
                  class="ion-text-end"
                  readonly
                  [value]="
                    patient.personalData?.surname
                      ? patient.personalData.surname + ' ' + patient.personalData.name
                      : ''
                  "
                  placeholder="Sconosciuto"
                >
                </ion-input>
              </ion-item>

              <ion-item>
                <ion-label><strong>Data di nascita</strong></ion-label>
                <ion-input
                  class="ion-text-end"
                  readonly
                  [value]="patient.personalData?.birthday | date: 'dd/MM/yyy'"
                  placeholder="Sconosciuta"
                >
                </ion-input>
              </ion-item>

              <ion-item *c3ShowTrecEnv="'development'">
                <ion-label><strong>TreC User Id</strong></ion-label>
                <ion-input class="ion-text-end" readonly [value]="patient.trecUserId"></ion-input>
              </ion-item>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- menu entries -->
    <ion-list-header class="section-header">
      <ion-icon
        class="ion-margin-end"
        [src]="'menu' | getIcon"
        color="secondary"
        size="large"
      ></ion-icon>
      <ion-label>Menu</ion-label>
    </ion-list-header>

    <ng-container *ngFor="let entry of menuEntries | keyvalue: entrySortOrder; let last = last">
      <ng-container *ngIf="!(entry.value.hide | async)">
        <ion-item
          button
          [routerLink]="entry.value.route"
          [queryParams]="entry.value.routeQueryParams"
          (click)="onClose()"
        >
          <ion-avatar slot="start" class="app-menu-icon">
            <img [src]="entry.value.image" />
          </ion-avatar>
          <ion-label>{{ entry.value.label }}</ion-label>
        </ion-item>
      </ng-container>
    </ng-container>
  </ion-list>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start" class="ion-margin-start">
      <!-- app version -->
      <span>Versione: {{ APP_VERSION }}</span>

      <!-- check updates btn -->
      <ion-button
        *ngIf="swUpdate.isEnabled"
        c3Tooltip="Controlla se ci sono nuovi aggiornamenti"
        (click)="onCheckUpdates()"
      >
        <ion-icon slot="icon-only" [src]="'reload' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <!-- credits btn -->
      <ion-button routerLink="credits" c3Tooltip="Credits e Contatti" (click)="onClose()">
        <ion-icon slot="icon-only" [src]="'information-outline' | getIcon"></ion-icon>
      </ion-button>

      <!-- close btn -->
      <ion-button (click)="onClose()" fill="clear">
        <ion-icon slot="start" [src]="'chevron-left' | getIcon"></ion-icon>
        <span class="ion-hide-sm-down">Chiudi</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
